import type { Mission } from '../missions.ts'

export const odni: Mission = {
  id: "odni",
  name: "Office of the Director of National Intelligence",
  short: "ODNI",
  call: "National Intelligence",
  kind: "independent",
  community: "intelligence",
  url: "https://www.odni.gov/",
  established: 2005,
  palette: {
    primary: "#122c50",
    secondary: "#234788",
    accent: "#fbbf15",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Office_of_the_Director_of_National_Intelligence.svg",
  },
  motif: "eagle",
  mission: {
    text: "Our mission is to lead intelligence integration and forge an Intelligence Community that delivers the most insightful intelligence possible.",
    url: "https://www.odni.gov/about/",
  },
  fact: {
    text: "The ODNI began operations on April 21, 2005, when the first Director of National Intelligence and Principal Deputy DNI were sworn in.",
    url: "https://www.odni.gov/about/",
  },
  seal: {
    file: "public/seals/odni.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_Office_of_the_Director_of_National_Intelligence.svg",
  },
  identifier: {
    about: "https://www.odni.gov/about/",
    foia: "https://www.odni.gov/accountability/#foia",
    noFear: "https://www.odni.gov/no-fear-act/",
    oig: "https://www.odni.gov/accountability/#icig",
    privacy: "https://www.odni.gov/policies/",
  },
  media: {
    photos: [
      {
        file: "/media/odni-ic-campus-bethesda.jpg",
        small: "/media/odni-ic-campus-bethesda-sm.jpg",
        alt: "A modern building with a rust-red slatted upper story above a glass ground floor, with a dark stone Intelligence Community Campus sign and landscaped beds in front.",
        title: "Intelligence Community Campus-Bethesda, January 27, 2017",
        creator: "Office of the Director of National Intelligence",
        source: "https://commons.wikimedia.org/wiki/File:Intelligence_Community_Campus-Bethesda_2017.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
